import { Guid } from 'guid-typescript';
import { UiStyle } from '../enums/ui-style';
import { UIWorkItemModel } from 'e5core-angular-services';
import { FieldSetModel } from './field-set.model';

/**
 * This class implements a

     UIWorkItemModel {
        fieldsets: UIFieldSetModel[] | undefined ;
        menus: UIMenuModel[] | undefined ;
        properties: UIPropertyModel[] | undefined ;
        tabs: UITabModel[] | undefined ;
        workId: string | undefined
    }
 */
export class WorkItemModel extends UIWorkItemModel implements FieldSetModel {
    constructor() {
        super();
        this.menus = null ;
        this.tabs = null ;
        this.workId = null ;
        this.fieldsets = null ;
        this.properties = null ;
    }
}

/**
 * DEPRECATED, use FieldValue
 * @param model
 * @param propertyId 
 * @param defaultValue 
 */
export function PropertyValue(model:WorkItemModel, propertyId:string, defaultValue?:string):string {
    let value:string = undefined ;
    if(model && propertyId && model.properties) {
        const property = model.properties.find(p => p.propertyId == propertyId) ;
        value = (property) ? property.value : undefined ;
    }
    return (value == undefined && defaultValue) ? defaultValue : value ;
}

export function FieldValue(model:WorkItemModel, fieldId:string, defaultValue?:string):string {
    return PropertyValue(model, fieldId, defaultValue) ;
}

/**
 * DEPRECATED, use ResolvedFieldValue
 * @param model
 * @param propertyId 
 * @param defaultValue 
 */
export function ResolvedPropertyValue(model:WorkItemModel, propertyId:string, defaultValue?:string):string {
    let value:string = undefined ;
    if(model && propertyId && model.properties) {
        const property = model.properties.find(p => p.propertyId == propertyId) ;
        value = (property) ? property.resolvedValue : undefined ;
    }
    return (value == undefined && defaultValue) ? defaultValue : value ;
}

export function ResolvedFieldValue(model:WorkItemModel, fieldId:string, defaultValue?:string):string {
    return ResolvedPropertyValue(model, fieldId, defaultValue) ;
}

export function CreateBlankWorkItem(): WorkItemModel {
    return new WorkItemModel() ;
}
